import ObjectTableController from "./object_table_controller"

export default class ExchangeTopicRecordsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    enableEdit: false,
    enableFieldSelection: false,
    isFavouriteEnabled: false,
  }
}
